import React from 'react';
import Typography from '@mui/material/Typography';

export default function ApplicationVersion() {
  return (
    <Typography sx={{ color: 'secondary.main' }}>v{process.env.REACT_APP_APPLICATION_VERSION}</Typography>
  )
};

